import totalVisitsModule from "./totalVisitsModule";
import BookingsReducer from "./redux/totalVisitsReducer";
import TotalVisitsSaga from "./redux/totalVisitsSagas";

export default {
  Component: totalVisitsModule,
  moduleName: "totalVisits",
  saga: TotalVisitsSaga(),
  reducer: BookingsReducer
};
